import { useEventConfig } from '@/eventConfig/useEventConfig.ts';
import { translate } from '@/translation/translate.ts';
import { EditDataField } from '@/components/slides/DataSummary/components/EditDataField.tsx';
import { addReqiredMessage } from '@/components/slides/DataSummary/util/addRequiredMessage.ts';
import { useSummaryFormField } from '@/components/slides/DataSummary/components/useSummaryFormField.ts';
import { EditSaveButtons } from '@/components/slides/DataSummary/components/EditSaveButtons.tsx';
import { useForm } from '@/form/useForm.ts';

export const AddressSummaryFormGB = () => {
  const { onStartEdit, onCancelEdit, onSave, editMode, isValid } = useSummaryFormField({ slideIds: ['address'] });

  const { getFieldValue } = useForm();

  const { eventConfig } = useEventConfig();
  const s = eventConfig!.slides;

  const apartmentField = s.address.fields.find(({ name }) => name === 'apartment');
  const apartmentLabel = translate(apartmentField?.label);

  const houseField = s.address.fields.find(({ name }) => name === 'house');
  const houseLabel = translate(houseField?.label);

  const housenoField = s.address.fields.find(({ name }) => name === 'houseno');
  const housenoLabel = translate(housenoField?.label);

  const roadField = addReqiredMessage({
    field: s.address.fields.find(({ name }) => name === 'roadName'),
    message: s.dataSummary.requiredMessage!,
  });
  const roadLabel = translate(roadField?.label);

  const townField = addReqiredMessage({
    field: s.address.fields.find(({ name }) => name === 'town'),
    message: s.dataSummary.requiredMessage!,
  });
  const townLabel = translate(townField?.label);

  const countyField = s.address.fields.find(({ name }) => name === 'county');
  const countyLabel = translate(countyField?.label);

  const postCodeField = s.address.fields.find(({ name }) => name === 'postcode');
  const postCodeLabel = translate(postCodeField?.label);

  return (
    <div className="summary-card" data-cy={'summary-form-address'}>
      <h2>{translate(s.dataSummary.titles?.address)}</h2>
      <EditSaveButtons
        editMode={editMode}
        onSave={onSave}
        onStartEdit={onStartEdit}
        onCancelEdit={onCancelEdit}
        isValid={isValid}
      />

      <div className="data">
        <div className={'label'}>{apartmentLabel}</div>
        <div className={'value'}>
          {!editMode && getFieldValue('apartment')}
          {editMode && <EditDataField field={apartmentField!} slideId={'address'} />}
        </div>

        <div className={'label'}>{houseLabel}</div>
        <div className={'value'}>
          {!editMode && getFieldValue('house')}
          {editMode && <EditDataField field={houseField!} slideId={'address'} />}
        </div>

        <div className={'label'}>{housenoLabel}</div>
        <div className={'value'}>
          {!editMode && getFieldValue('houseno')}
          {editMode && <EditDataField field={housenoField!} slideId={'address'} />}
        </div>

        <div className={'label'}>{roadLabel}</div>
        <div className={'value'}>
          {!editMode && getFieldValue('roadName')}
          {editMode && <EditDataField field={roadField!} slideId={'address'} />}
        </div>

        <div className={'label'}>{townLabel}</div>
        <div className={'value'}>
          {!editMode && getFieldValue('town')}
          {editMode && <EditDataField field={townField!} slideId={'address'} />}
        </div>

        <div className={'label'}>{countyLabel}</div>
        <div className={'value'}>
          {!editMode && getFieldValue('county')}
          {editMode && <EditDataField field={countyField!} slideId={'address'} />}
        </div>

        <div className={'label'}>{postCodeLabel}</div>
        <div className={'value'}>
          {!editMode && getFieldValue('postcode')}
          {editMode && <EditDataField field={postCodeField!} slideId={'address'} />}
        </div>
      </div>
    </div>
  );
};
